import axios, { buildApi } from '@/libs/api.request';
let name = '/shipments/tt/prediction'

export const apis = buildApi({
  get: [name + '&list',],
  post: [name + '/save', name + '/delete/:id&del']
})